module.exports = __webpack_public_path__ + "r-v3/img/ico_wonder.436b7da7.svg";